import { createColumnHelper } from '@tanstack/react-table';

import i18n from '@/core/i18n';

import { TimeOffRequest } from '../../types/time-off-request';
import { TimeOffTimeCategory } from '../../types/time-off-time-category';
import {
  buildTimeOffApproversColumn,
  buildTimeOffDateRangeColumn,
  buildTimeOffDescriptionColumn,
  buildTimeOffDurationColumn,
  buildTimeOffPartOfDayColumn,
  buildTimeOffStatusColumn,
  buildTimeOffTimeCategoryColumn,
  buildTimeOffTypeColumn,
} from '../table/time-offs-table-columns';
import { TimeOffApprovalActionsCell } from './cells/time-off-approval-actions-cell';
import { TimeOffEmployeeCell } from './cells/time-off-employee-cell';

const columnHelper = createColumnHelper<TimeOffRequest>();

const isPastRow = (row: TimeOffRequest) => row.timeCategory === TimeOffTimeCategory.Past;

/**
 * Approvals table columns: an Employee column up front, the shared Time-Offs
 * columns in the middle (Description sits before Approvers; Status and Approvers
 * carry their hover tooltips), and an Actions column (approve/decline) at the
 * far right. Headers are plain strings so `DataTableColumnsSelector` can label toggles.
 */
export const getTimeOffApprovalsTableColumns = () => [
  columnHelper.display({
    id: 'employee',
    header: i18n.t('authenticated.timeOff:approvals.table.columns.employee'),
    enableHiding: false,
    size: 220,
    minSize: 160,
    cell: ({ row }) => (
      <TimeOffEmployeeCell employee={row.original.requestedBy} isPast={isPastRow(row.original)} />
    ),
  }),
  buildTimeOffTypeColumn(),
  buildTimeOffStatusColumn(),
  buildTimeOffDateRangeColumn(),
  buildTimeOffDurationColumn(),
  buildTimeOffPartOfDayColumn(),
  buildTimeOffDescriptionColumn(),
  buildTimeOffApproversColumn(),
  buildTimeOffTimeCategoryColumn(),
  columnHelper.display({
    id: 'actions',
    header: () => (
      <div className="flex w-full justify-center">
        {i18n.t('authenticated.timeOff:table.columns.actions')}
      </div>
    ),
    size: 90,
    minSize: 80,
    enableResizing: false,
    enableHiding: false,
    cell: ({ row }) => (
      <div className="flex justify-center">
        <TimeOffApprovalActionsCell request={row.original} />
      </div>
    ),
  }),
];
